import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import News from "@/pages/News";
import Contact from "@/pages/Contact";
import BookingInquiry from "@/pages/BookingInquiry";
import IStayWithMe from "@/pages/IStayWithMe";
import Policies from "@/pages/Policies";
import History from "@/pages/History";
import Board from "@/pages/Board";
import Directions from "@/pages/Directions";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={withLayout(<Home />)} />
          <Route path="/about" element={withLayout(<About />)} />
          <Route path="/gallery" element={withLayout(<Gallery />)} />
          <Route path="/news" element={withLayout(<News />)} />
          <Route path="/contact" element={withLayout(<Contact />)} />
          <Route path="/booking" element={withLayout(<BookingInquiry />)} />
          <Route path="/events/i-stay-with-me" element={withLayout(<IStayWithMe />)} />
          <Route path="/policies" element={withLayout(<Policies />)} />
          <Route path="/history" element={withLayout(<History />)} />
          <Route path="/board" element={withLayout(<Board />)} />
          <Route path="/directions" element={withLayout(<Directions />)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={withLayout(<Home />)} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
